import { Component, OnInit, Input, inject } from '@angular/core';
import { IComponentSection } from '../../../interfaces/component-section';
import { IBrandInfo } from '../../../interfaces/brand/brand-info';
import { SharedService } from '../../../services/shared.service';

@Component({
    selector: 'app-brand-footer-disclaimer',
    templateUrl: './brand-footer-disclaimer.component.html',
    styleUrls: ['./brand-footer-disclaimer.component.css'],
    standalone: true
})
export class BrandFooterDisclaimerComponent implements OnInit, IComponentSection {
  @Input() data: any;

  private readonly sharedService = inject(SharedService);

  copyrightYear: number = new Date().getFullYear();
  disclaimerText!: string;
  isDisclaimerVisible: boolean = false;
    
  ngOnInit(): void {
    this.makeBrandFooter(this.data);
  }  

  makeBrandFooter (brandInfo: IBrandInfo) {
    this.disclaimerText = this.sharedService.getBrandConfigProperty(brandInfo, 'WAL_PAGES_FOOTER_DISCLAIMER_TEXT');
    if (this.disclaimerText) {
      this.disclaimerText = "@" + this.copyrightYear + " " + this.disclaimerText;
      this.isDisclaimerVisible = true;
    }
  }

}

